/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PageTypeConstants = {
    LoginPage: 'LoginPage',
    LogoutPage: 'LogoutPage',
    ShowPage: 'ShowPage',
    EditPage: 'EditPage',
    CreatePage: 'CreatePage',
    WizardPage: 'WizardPage',
    ExtendedPlasmidViewPage: 'ExtendedPlasmidViewPage',
    ExtendedHierarchyViewPage: 'ExtendedHierarchyViewPage'
} as const;
export type PageTypeConstants = typeof PageTypeConstants[keyof typeof PageTypeConstants];


export function PageTypeConstantsFromJSON(json: any): PageTypeConstants {
    return PageTypeConstantsFromJSONTyped(json, false);
}

export function PageTypeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageTypeConstants {
    return json as PageTypeConstants;
}

export function PageTypeConstantsToJSON(value?: PageTypeConstants | null): any {
    return value as any;
}

